import { render } from "./payType.vue?vue&type=template&id=544b284c&scoped=true"
import script from "./payType.vue?vue&type=script&lang=js"
export * from "./payType.vue?vue&type=script&lang=js"

import "./payType.vue?vue&type=style&index=0&id=544b284c&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544b284c"]])

export default __exports__